module.exports = {
      id: "check-list-active-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#check-list-active",
      toString: function () {
        return this.url;
      }
    }